<div *ngFor="let item of toasterList; let i=index" id="tToaster{{item.id}}" class="tt-cnt tt-{{item.messageType}}" style="display: none;" [ngStyle]="{'bottom': setToastBottom(i)}"
    [ngClass]="{'tt-cnt-mobile' : isMobile}">
    <div class="tt-message-cnt">
        <span class="tt-message-span" [ngClass]="{'tt-message-span-mobile' : isMobile}">{{item.message}}</span>
    </div>
    <div class="tt-icon-cnt">
        <span class="tt-icon" [ngClass]="{'tt-icon-mobile' : isMobile}" (click)="onCloseToastClick(item.id)">&#10539;</span>
    </div>
</div>
